import React, { useEffect, useState } from "react";
import * as bootstrap from "bootstrap";
import Select from "react-select";
import Chip from "@mui/material/Chip";
import Button from "../../../../components/Button";

const AddChargeCodeModal = ({ show, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    charge_code: "",
    sac_codes: [],
    segment: [],
    tax_percentage: "",
    currencies: "",
  });

  // SAC Code input
  const [sacCodeInput, setSacCodeInput] = useState("");

  const segments = [
    {
      value: "FE",
      label: "FE",
    },
    {
      value: "LE",
      label: "LE",
    },
    {
      value: "LI",
      label: "LI",
    },
    {
      value: "FI",
      label: "FI",
    },
  ];

  // -----------------------------
  // Bootstrap Modal
  // -----------------------------

  useEffect(() => {
    const modalElement = document.getElementById("addChargeCodeModal");

    if (!modalElement) return;

    const modal =
      bootstrap.Modal.getOrCreateInstance(modalElement);

    if (show) {
      modal.show();
    } else {
      modal.hide();
    }
 
    const handleHidden = () => {
      onClose();
    };

    modalElement.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement.removeEventListener(
        "hidden.bs.modal",
        handleHidden
      );
    };
  }, [show, onClose]);

  // -----------------------------
  // Add SAC Code
  // -----------------------------

  const addSacCode = () => {
    const trimmedCode = sacCodeInput.trim();

    // Empty value add nahi hogi
    if (!trimmedCode) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      sac_codes: [...prev.sac_codes, trimmedCode],
    }));

    // Input clear after adding
    setSacCodeInput("");
  };

  // -----------------------------
  // Remove SAC Code
  // -----------------------------

  const removeSacCode = (index) => {
    setFormData((prev) => ({
      ...prev,
      sac_codes: prev.sac_codes.filter(
        (_, i) => i !== index
      ),
    }));
  };

  // -----------------------------
  // Submit
  // -----------------------------

  const handleSubmit = async (e) => {
    e.preventDefault();
 
    try {
      const cleanedFormData = {
        ...formData,
        sac_codes: formData.sac_codes.filter(
          (code) => code.trim() !== ""
        ),
      };

      console.log("Form Data:", cleanedFormData);

      // API call here
      // await api.post("/charge_code", cleanedFormData);

      await onSuccess();

      const modalElement = document.getElementById("addChargeCodeModal");
      const modal = bootstrap.Modal.getInstance(modalElement);

      if (modal) {
        modal.hide();
      }
    } catch (error) {
      console.error(error);
    }
  };
 
  return (
    <div
      className="modal fade"
      id="addChargeCodeModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Add Charge Code</h5>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            />
          </div>
 
          <form onSubmit={handleSubmit}>
            <div className="modal-body">

              {/* Charge Code */}
              <div className="mb-3">
                <label className="form-label">
                  Charge Code
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Charge Code"
                  value={formData.charge_code}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      charge_code: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="mb-3">
                <label className="form-label mb-2">
                  SAC Codes
                </label>

                {/* SAC Code Input + Add */}
                <div className="d-flex align-items-center gap-2">
                  <div className="flex-grow-1">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter SAC Code"
                      value={sacCodeInput}
                      onChange={(e) =>
                        setSacCodeInput(e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          addSacCode();
                        }
                      }}
                    />
                  </div>

                  <Button
                    type="button"
                    variant="primary"
                    size="sm"
                    btncls="px-2"
                    text="+"
                    onClick={addSacCode}
                    title="Add SAC Code"
                  />
                </div>

                {/* SAC Code Chips */}
                {formData.sac_codes.length > 0 && (
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {formData.sac_codes.map(
                      (sacCode, index) => (
                        <Chip
                          key={`${sacCode}-${index}`}
                          label={sacCode}
                          variant="outlined"
                          onDelete={() =>
                            removeSacCode(index)
                          }
                          sx={{
                            backgroundColor: "#f1f3f5",
                            borderColor: "#dee2e6",
                            color: "#495057",
                            fontWeight: 500,
                            borderRadius: "6px",
                            height: "34px",

                            "& .MuiChip-deleteIcon": {
                              color: "#787a7c",
                              fontSize: "18px",
                            },

                            "& .MuiChip-deleteIcon:hover": {
                              color: "#b02a37",
                            },
                          }}
                        />
                      )
                    )}
                  </div>
                )}
              </div>

              {/* Segment Multi Select */}
              <div className="mb-3">
                <label className="form-label">
                  Segment
                </label>

                <Select
                  options={segments}
                  isMulti
                  value={segments.filter((option) =>
                    formData.segment.includes(
                      option.value
                    )
                  )}
                  onChange={(selectedOptions) => {
                    setFormData((prev) => ({
                      ...prev,
                      segment: selectedOptions
                        ? selectedOptions.map(
                            (option) => option.value
                          )
                        : [],
                    }));
                  }}
                  placeholder="Select segment"
                  isClearable
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  GST %
                </label>

                <input
                  type="number"
                  className="form-control"
                  value={formData.tax_percentage}
                  placeholder="Enter GST %"
                  min="0"
                  step="0.01"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      tax_percentage: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Currencies
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Currencies"
                  value={formData.currencies}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      currencies: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="modal-footer">
              <Button
                type="button"
                variant="secondary"
                text="Cancel"
                onClick={onClose}
              >
                Cancel
              </Button>

              <button type="submit" className="btn btn-primary">
                Add Charge Code
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
 
export default AddChargeCodeModal;
